'use client';

import React from 'react';
import { UserCircle } from 'lucide-react';

export default function ProfileHeader() {
  return (
    <div className="px-6 py-4 border-b border-[hsl(var(--border))] bg-white shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-[hsl(var(--primary)/0.08)] border border-[hsl(var(--primary)/0.15)] flex items-center justify-center shrink-0">
          <UserCircle size={16} className="text-[hsl(var(--primary))]" />
        </div>
        <div>
          <h1 className="text-lg font-bold text-[hsl(var(--foreground))]">Profile & Account</h1>
          <p className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">
            Manage your Strava connection, sync status, and data refresh settings
          </p>
        </div>
      </div>
    </div>
  );
}
